import { surveyLocalization } from "../surveyStrings";

export var romanianSurveyStrings: any = {
  pagePrevText: "Precedent",
  pageNextText: "Următor",
  completeText: "Finalizare",
  otherItemText: "Altul(precizaţi)",
  progressText: "Pagina {0} din {1}",
  emptySurvey: "Nu sunt întrebări pentru acest chestionar",
  completingSurvey: "Vă mulţumim pentru timpul acordat!",
  loadingSurvey: "Chestionarul se încarcă...",
  optionsCaption: "Alegeţi...",
  requiredError: "Răspunsul la această întrebare este obligatoriu.",
  requiredInAllRowsError: "Toate răspunsurile sunt obligatorii",
  numericError: "Răspunsul trebuie să fie numeric.",
  textMinLength: "Trebuie să introduceți minim {0} caractere.",
  minSelectError: "Trebuie să selectați minim {0} opţiuni.",
  maxSelectError: "Trebuie să selectați maxim {0} opţiuni.",
  numericMinMax:
    "Răspunsul '{0}' trebuie să fie mai mare sau egal ca {1} şî mai mic sau egal cu {2}",
  numericMin: "Răspunsul '{0}' trebuie să fie mai mare sau egal ca {1}",
  numericMax: "Răspunsul '{0}' trebuie să fie mai mic sau egal ca {1}",
  invalidEmail: "Trebuie să introduceţi o adresa de email validă.",
  exceedMaxSize: "Dimensiunea fişierului nu trebuie să depăşească {0}.",
  otherRequiredError: "Trebuie să completați câmpul 'Altul'.",
  completingSurveyBefore:
    "Din înregistrările noastre reiese că ați completat deja acest chestionar.",
  value: "valoare",
  requiredErrorInPanel: "Vă rugăm să răspundeți la cel puțin o întrebare.",
  textMaxLength: "Trebuie să introduceți maxim {0} caractere.",
  textMinMaxLength:
    "Trebuie să introduceți mai mult de {0} și mai puțin de {1} caractere.",
  minRowCountError: "Trebuie să completați minim {0} rânduri.",
  urlRequestError: "Request-ul a returnat eroarea '{0}'. {1}",
  urlGetChoicesError:
    "Request-ul nu a returnat date sau proprietatea 'path' este incorectă",
  uploadingFile:
    "Fișierul dumneavoastră este în curs de încărcare. Vă rugăm așteptați câteva secunde și reveniți apoi.",
  confirmDelete: "Sunteți sigur că doriți să ștergeți înregistrarea?",
  keyDuplicationError: "Valoarea trebuie să fie unică.",
  addRow: "Adăugare rând",
  removeRow: "Ștergere",
  addPanel: "Adăugare",
  removePanel: "Ștergere",
  choices_Item: "opțiune",
  matrix_column: "Coloană",
  matrix_row: "Rând",
  savingData: "Rezultatele sunt în curs de salvare...",
  savingDataError: "A intervenit o eroare, rezultatele nu au putut fi salvate.",
  savingDataSuccess: "Rezultatele au fost salvate cu succes!",
  saveAgainButton: "Încercați din nou",
  timerMin: "min",
  timerSec: "sec",
  timerSpentAll: "Ați petrecut {0} pe această pagină și {1} în total.",
  timerSpentPage: "Ați petrecut {0} pe această pagină.",
  timerSpentSurvey: "Ați petrecut {0} în total.",
  timerLimitAll:
    "Ați petrecut {0} din {1} pe această pagină și {2} din {3} în total.",
  timerLimitPage: "Ați petrecut {0} din {1} pe această pagină.",
  timerLimitSurvey: "Ați petrecut {0} din {1} în total."
};
surveyLocalization.locales["ro"] = romanianSurveyStrings;
surveyLocalization.localeNames["ro"] = "română";



// WEBPACK FOOTER //
// ./src/localization/romanian.ts